import moment from 'moment';

export const filterList = ({ massMessages = [], filters, startDate, endDate, assocStores }) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id.toString());

  return massMessages?.filter(massMessage => {
    const filterStore =
      filters.store.length === 0
        ? allStores.includes(massMessage?.activity_store_id.toString())
        : filters.store.includes(massMessage?.activity_store_id?.toString());
    const filterAssociate =
      filters.associate.length === 0 || filters.associate.includes(massMessage.activity_associate_id.toString());
    // activity_date is stored as date-only string (YYYY-MM-DD) in UTC
    // Parse both as UTC and compare at UTC level to avoid timezone shifts
    const activityDateUTC = moment.utc(massMessage.activity_date);
    const filterTimeSpan = activityDateUTC.isBetween(
      moment.utc(startDate).startOf('day'),
      moment.utc(endDate).endOf('day'),
      'millisecond',
      '[]',
    );
    return filterStore && filterAssociate && filterTimeSpan;
  });
};

export const filterMassMsgMeta = (massMessages, { startDate, endDate }, associates = []) => {
  return massMessages?.filter(massMessage => {
    const filterAssociate = associates.length === 0 || associates.includes(massMessage?.associate_id?.toString());
    // scheduled_date_time is stored as date-only string (YYYY-MM-DD) in UTC
    // Parse both as UTC and compare at UTC level to avoid timezone shifts
    const scheduledDateUTC = moment.utc(massMessage.scheduled_date_time);
    const filterTimeSpan = scheduledDateUTC.isBetween(
      moment.utc(startDate).startOf('day'),
      moment.utc(endDate).endOf('day'),
      'millisecond',
      '[]',
    );
    return filterAssociate && filterTimeSpan;
  });
};
